<eo-dropdown
  [id]="id"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [tabindex]="getTabIndex()"
  [options]="getOptions()"
  [optionLabel]="getOptionLabel()"
  [optionValue]="getOptionValue()"
  [placeholder]="getPlaceholder()"
  [showClear]="getShowClear()"
  [filter]="hasFilter()"
  [filterBy]="getFilterBy()"
  [filterFields]="getFilterFields()"
  [filterPlaceholder]="getFilterPlaceholder()"
  [appendTo]="getAppendTo()"
  [loading]="isLoading()"
  [config]="getConfig()"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
  (onFilter)="onFilterHandler($event)"
/>
